// extracted by mini-css-extract-plugin
export var resizer = "_hw-0";